<template>
  <div class="body">
    <div class="detay">
      <div class="sayfahead tek">
        <h1>Web Site Yönetimi</h1>
      </div>
      <div class="icerik">
        <Yukleniyor :data="lo"></Yukleniyor>
        <div class="frame">
          <!--iframe v-if="WebYetki" :src="'https://panel.bina.site/giris/'+Url+'/'+id"></iframe-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Yukleniyor from "../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      lo: true,
      WebYetki: false,
      Url: false,
    }
  },
  methods: {

    SayfaYukle() {
      this.$store.dispatch("Get", {path: '_web'})
        .then(response => {
          this.lo = false;
          if (response.Durum == 'OK') {
            this.WebYetki = true;
            this.Url = response.Url;

            window.open(this.Url, "MsgWindow", "toolbar=no,scrollbars=no,resizable=no,top=100,left=100,width=1366,height=768");

          } else {
            this.WebYetki = false;
          }
        })
    },
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>
.frame {
}

iframe {
  width: 100%;
  height: 80vh;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/_web/_route.vue